module.exports = __webpack_public_path__ + "static/media/fwd_logo.1ce6e351.png";